import classNames from 'classnames'
import { useSearchParams } from 'react-router-dom'

import { ReactComponent as Op36Logo } from '../assets/images/logos/horizontal-logo.svg'
import backgroundVideo from './../assets/videos/welcome-page-background-video.mp4'
import backgroundVideoPoster from './../assets/images/welcome-page-background-video-poster.webp'
import { buildSignInUrl, buildSignUpUrl } from '../constants/oauth'
import ButtonLink from './common/buttons/ButtonLink'
import AccountSegmentSelector from './auth/common/AccountSegmentSelector'
import PrivacyTermsFooter from './auth/common/PrivacyTermsFooter'

import classes from './WelcomePage.module.scss'

const WelcomePage = () => {
  const communityId = localStorage.getItem('communityId')
  const [searchParams] = useSearchParams()

  const signInUrl = buildSignInUrl(communityId, searchParams)

  const handleSignIn = () => {}

  const handleIndividualSignUp = () => {
    window.location.href = buildSignUpUrl('individual', communityId, searchParams)
  }

  const handleFamilySignUp = () => {
    window.location.href = buildSignUpUrl('family', communityId, searchParams)
  }

  return (
    <main className={classNames(classes.welcomePage, 'd-flex flex-md-row')}>
      <aside className={classes.backgroundPanel}>
        <video autoPlay loop muted poster={backgroundVideoPoster} className={classes.backgroundVideo}>
          <source src={backgroundVideo} type='video/mp4'/>
        </video>
      </aside>

      <section className={classNames(classes.actionPanel, 'd-flex flex-column align-items-center justify-content-end p-2')}>
        <div className={classNames(classes.mobileView, 'flex-column align-items-center w-100')}>
          <Op36Logo className={classes.op36Logo}/>
          <h2 className={classNames(classes.logoText, 'mt-3')}>The #1 Way To Learn To Play Golf</h2>

          <ButtonLink navigateTo='sign-up/oauth' className={classNames(classes.actionLink, 'mt-4')}>
            Create an Account
          </ButtonLink>

          <ButtonLink
            linkColor='white' navigateTo={signInUrl} onClick={handleSignIn} className={classNames(classes.actionLink, 'mt-4 mb-5')} isExternal
          >
            Log In
          </ButtonLink>
        </div>

        <div className={classNames(classes.desktopView, 'flex-column justify-content-center w-50 h-100')}>
          <div className='d-flex flex-column align-items-center w-100'>
            <Op36Logo className={classes.op36Logo}/>
            <h2 className={classNames(classes.logoText, 'mt-3')}>The #1 Way To Learn To Play Golf</h2>

            <ButtonLink navigateTo={signInUrl} onClick={handleSignIn} className={classNames(classes.actionLink, 'mt-4')} isExternal>
              Log In
            </ButtonLink>
          </div>

          <div className='d-flex flex-column align-items-center'>
            <p className={classNames(classes.signUpSubtitle, 'w-100')}>Don&apos;t have an account?</p>

            <AccountSegmentSelector
              onIndividualClick={handleIndividualSignUp}
              onFamilyClick={handleFamilySignUp}
              wrapperClassName='mb-3'
            />

            <PrivacyTermsFooter />
          </div>
        </div>
      </section>
    </main>
  )
}

export default WelcomePage
